var map = {
	"./angpao.webp": 2256,
	"./bonus.webp": 2257,
	"./gpi-rebate-m.webp": 2258,
	"./gpi-rebate.webp": 2259,
	"./hublot-watch-2018.webp": 2260,
	"./hublot-watch-2022.webp": 2261,
	"./iphone-13-pro-max.webp": 2262,
	"./iphone-14-pro-max.webp": 2263,
	"./login-to-m.webp": 2264,
	"./login-to.webp": 2265,
	"./mb.webp": 2266,
	"./mg-rebate-m.webp": 2267,
	"./mg-rebate.webp": 2268,
	"./np.webp": 2269,
	"./pointer.webp": 2270,
	"./pp-rebate-m.webp": 2271,
	"./pp-rebate.webp": 2272,
	"./sadface.webp": 2273,
	"./wallet-m.webp": 2274,
	"./wallet.webp": 2275,
	"./wheel-b.webp": 2276,
	"./wheel-btn.webp": 2277,
	"./wheel-indon-b.webp": 2278,
	"./wheel-indon.webp": 2279,
	"./wheel.webp": 2280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 894;